<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M17.41 26.09a2 2 0 01-2.82 0L5 16.5a6.8 6.8 0 01.66-10.2 7 7 0 019.1.76L16 8.3l1.24-1.24a7 7 0 019.1-.76A6.8 6.8 0 0127 16.5z"/></svg>